module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    attrs: {
      "label-position": _vm.labelPosition,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身高(cm)："
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入身高"
    },
    model: {
      value: (_vm.observed.stature),
      callback: function($$v) {
        _vm.$set(_vm.observed, "stature", $$v)
      },
      expression: "observed.stature"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "体重(kg)："
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入体重"
    },
    model: {
      value: (_vm.observed.weight),
      callback: function($$v) {
        _vm.$set(_vm.observed, "weight", $$v)
      },
      expression: "observed.weight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "体温(℃)："
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入体温"
    },
    model: {
      value: (_vm.observed.animalHeat),
      callback: function($$v) {
        _vm.$set(_vm.observed, "animalHeat", $$v)
      },
      expression: "observed.animalHeat"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "血压(mmHg)："
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入血压"
    },
    model: {
      value: (_vm.observed.bloodPressure),
      callback: function($$v) {
        _vm.$set(_vm.observed, "bloodPressure", $$v)
      },
      expression: "observed.bloodPressure"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "心率(次/分钟)："
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入心率"
    },
    model: {
      value: (_vm.observed.heartRate),
      callback: function($$v) {
        _vm.$set(_vm.observed, "heartRate", $$v)
      },
      expression: "observed.heartRate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "血糖(mmol/L)："
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入血糖"
    },
    model: {
      value: (_vm.observed.blood),
      callback: function($$v) {
        _vm.$set(_vm.observed, "blood", $$v)
      },
      expression: "observed.blood"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "inOne-TabBttom"
  }, [(_vm.exhibition) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.futureSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v("保存")]) : _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.resetData()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("重置")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e5c35f0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/inquiry/inquiryChecks.vue
// module id = 998
// module chunks = 2